<template>
    <div>
        <b-modal ref="add-novo-template"
        size="md"
        centered
        title="novo template"
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        body-class="rounded-bottom-1rem"
        content-class="rounded-1rem"
        >
        <template #modal-title>
            <div class="header-title">NOVO TEMPLATE {{ tipoFluxo }}</div>
        </template>
          <div class="container-new-template">
            <b-form-group
                  class="font"
                  id="Input-group-template"
                  label="Item Avaliação *"
                  label-for="input-template"
                >
                <b-form-input
                  class="input"
                  id="input-new-template"
                  name="input-new-template"
                  type="text"
                  v-model="formSearch.descricao"
                  v-validate="{ alpha_spaces: true, required: true }"
                  :state="validateState('descricao-item-avaliacao')"
                  placeholder="Digíte a descrição"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                  class="font pivs"
                  id="Input-group-template-pes"
                  :label="tipoFluxo === 'PIVS' ? 'Código PIVS *' : tipoFluxo === 'PIT' ? 'Código PIT *' : 'Código LV'"
                  label-for="input-template-pes"
                >
                <b-form-input
                  class="input"
                  id="input-new-pes"
                  name="input-new-pes"
                  type="text"
                  v-model="formSearch.codigo"
                  v-validate="{ alpha_spaces: true, required: true }"
                  :state="validateState('codigo-pes')"
                  placeholder="Digíte o Código"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                  v-if="tipoFluxo === 'PIVS'"
                  class="font pivs"
                  id="Input-group-template-pes"
                  label="Código PES"
                  label-for="input-template-pes"
                >
                <b-form-input
                  class="input"
                  id="input-new-pes"
                  name="input-new-pes"
                  type="text"
                  v-model="formSearch.pes"
                  v-validate="{ alpha_spaces: true, required: true }"
                  :state="validateState('codigo-pes')"
                  placeholder="Digite o Código"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                  class="font pivs"
                  id="Input-group-template-revisao"
                  label="Revisão *"
                  label-for="input-template-revisao"
                >
                <b-form-input
                  class="input"
                  id="input-new-revisao"
                  name="input-new-revisao"
                  type="number"
                  min="0"
                  step="1"
                  v-model.number="formSearch.revisao"
                  placeholder="Número da revisão"
                ></b-form-input>
            </b-form-group>

            <div class="d-flex container_cancel_save">
              <div class="cancelar">
                  <button class="button-cancel" @click="fecharPopUptAdd">CANCELAR</button>
              </div>
              <div class="criar" v-if="editar === false">
                <button class="button-save" @click="verificaCampos">SALVAR</button>
              </div>
              <div class="criar" v-else>
                <button class="button-save" @click="verificaCampos">EDITAR</button>
              </div>
            </div>
          </div>
        </b-modal>
     </div>
</template>

<script>
import newTemplate from './newTemplate'
export default newTemplate
</script>

  <style scoped>
  .pivs{
    margin-top: 1rem;
  }
  .container_input{
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .input{
    width: 100%;
    border-radius: 5px;
  }
  .container-new-template{
    width: 100%;
  }
  .font {
    width: 100%;
    font-family: 'Segoe UI';
    font-size: 14px;
    font-weight: bold;
    color: #505050;
  }
  .header-title{
    color: white;
    font-weight: bold;
    font-size: 16px;
    font-family: 'Segoe UI';
  }
   .container_cancel_save{
    justify-content: center;
    width: 100%;
    margin-top: 1.5rem;
    column-gap: 10px;
   }
  .button-cancel,
  .button-save{
    margin-top: 1rem;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 170px;
    height: 35px;
    font-family: 'Segoe UI';
    font-size: 12px;
    font-weight: bold;
  }
  .button-cancel{
    background-color: #b60000;
    color: white;
  }
  .button-save{
    background-color: darkgreen;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaTemplate/newTemplate/newTemplate.vue